import React, { useEffect } from "react";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import About from "../Component/About/About";
import Services from "../Component/Services/Services";
import Gallery from "../Component/Gallery/Gallery";
import Blog from "../Component/Blog/Blog";
import Contact from "../Component/Contact/Contact";
import Home from "../Component/Home/Home";
import Header from "../Component/Header/Header";
import RegistrationPage from "../Component/RegistrationPage/RegistrationPage";
import ForgotPassword from "../Component/ForgotPassword/ForgotPassword";
import RegistrationVarification from "../Component/RegistrationVarification/RegistrationVarification";
import GenderPage from "../Component/GenderPage/GenderPage";
import UploadImage from "../Component/UploadImage/UploadImage";
import DocumentUpload from "../Component/DocumentUpload/DocumentUpload";
import CultureReligion from "../Component/CultureReligion/CultureReligion";
import Interest from "../Component/Interest/Interest";
import TemperamentQuestion from "../Component/TemperamentQuestion/TemperamentQuestion";
import ValuesAssessment from "../Component/ValuesAssessment/ValuesAssessment";
import IQAssessment from "../Component/IQAssessment/IQAssessment";
import { getUserById } from "../Component/api/api";
import Verification from "../Component/Verification/Verification";
import AuthPage from "../Component/AuthPage/AuthPage";
import UserHomePage from "../UserPage/UserHomePage";
import Sidebar from "../Sidebar/Sidebar";
import Notification from "../Component/Notification/Notification";
import TermsandCondition from "../Component/TermsandCondition/TermsandCondition";
import PrivacyPolicy from "../Component/PrivacyPolicy/PrivacyPolicy";
import HelpandSupport from "../Component/HelpandSupport/HelpandSupport";
import MemberProfile from "../Component/MemberProfile/MemberProfile";
import Messages from "../Component/Messages/Messages";
import Chat from "../Component/Chat/Chat";
import EditProfile from "../Component/EditProfile/EditProfile";
import Profile from "../Component/Profile/Profile";
import UserBasicDetailsEdit from "../Component/UserProfileEdit/UserBasicDetailsEdit";
import UserImageEdit from "../Component/UserProfileEdit/UserImageEdit";
import ResetPassword from "../Component/UserProfileEdit/ResetPassword";
import EditInterest from "../Component/UserProfileEdit/EditInterest";
import EditCultureReligion from "../Component/UserProfileEdit/EditCultureReligion";
import SetResetPassword from "../Component/SetResetPassword/SetResetPassword";
import AdminSupport from "../Component/HelpandSupport/AdminSupport";
import PaymentDispute from "../Component/HelpandSupport/PaymentDispute";
import TechSupport from "../Component/HelpandSupport/TechSupport";
// import FinalSubmissionPage from "../Component/FinalSubmissionPage/FinalSubmissionPage";
import FinalSubmissionPage from "../Component/FinalSubmissionPage/FinalSubmissionPage";
import PaymentHistory from "../Component/PaymentHistory/PaymentHistory";
import Consult from "../Component/Consult/Consult";
import ConsultPaymentWebView from "../Component/api/ConsultPaymentWebView";
import ChatConsult from "../Component/ChatConsult/ChatConsult";
import CounsellorRegistrations from "../Component/CounsellorRegistration/CounsellorRegistration";
import CounsellorForgotPassword from "../Component/CounsellorAllPages/CounsellorForgotPassword";
import CounsellorOtp from "../Component/CounsellorAllPages/CounsellorOtp";
import CounsellorEmailVerification from "../Component/CounsellorAllPages/CounsellorEmailVerification";
import CounsellorImageUpload from "../Component/CounsellorAllPages/CounsellorImageUpload";
import CounsellorDoucmentation from "../Component/CounsellorAllPages/CounsellorDocumentation";
import CounsellorFinalSubmission from "../Component/CounsellorAllPages/CounsellorFinalSubmission";
import CounsellorSidebar from "../Component/CounsellorSidebar/CounsellorSidebar";
import CounsellorBooking from "../Component/CounsellorAllPages/CounsellorBooking";
import Rating from "../Component/CounsellorAllPages/Rating";
import CounsellorEditProfile from "../Component/CounsellorAllPages/CounsellorEditProfile";
import CounsellorImageUpdate from "../Component/CounsellorAllPages/CounsellorallEditPages/CounsellorImageUpdate";
import Availabilityupdate from "../Component/CounsellorAllPages/CounsellorallEditPages/Availabilityupdate";
import CounsellorProfileEdit from "../Component/CounsellorAllPages/CounsellorallEditPages/CounsellorProfileEdit";
import Resetpassword from "../Component/CounsellorAllPages/CounsellorallEditPages/Resetpassword";
import CounsellorResetPassword from "../Component/CounsellorAllPages/CounsellorallEditPages/CounsellorResetPassword";
import CounsellorChat from "../Component/CounsellorAllPages/CounsellorChat";
import BookingDetails from "../Component/BookingDetails/BookingDetails";
import ConnectionPayment from "../Component/ConnectionPayment/ConnectionPayment";
import ConnectionPaymentWebView from "../Component/api/ConnectionPaymentWebView";
import InfluencerLoginPage from "../Component/InfluencerLoginPage/InfluencerLoginPage";
import InfluencerPage from "../Component/InfluencerPage/InfluencerPage";
import InfluencerResetPasswordPage from "../Component/InfluencerPage/InfluencerResetPasswordPage";
import InflucerEnterCode from "../Component/InfluencerPage/InfluencerEnterCode";
import PaymentScreen from "../Component/PaymentScreen/PaymentScreen";
import UpdateProfileDetails from "../Component/UpdateProfileDetails/UpdateProfileDetails";
import SubscriptionBlurPage from "../Component/SubscriptionBlurPage/SubscriptionBlurPage";
import SubscriptionPlans from "../Component/SubscriptionPlans/SubscriptionPlans";
import Lovelanguage from "../Component/Lovelanguage/Lovelanguage";
import UpdateMatchPreferences from "../Component/UpdateMatchPreferences/UpdateMatchPreferences";
import Subscription from "../Component/Subscription/Subscription";
import UpdateuploadProfileDetails from "../Component/UpdateProfileDetails/UpdateuploadProfileDetails";
import UpdateUploadMatchPreferences from "../Component/UpdateMatchPreferences/UpdateUploadMatchPreferences";
import QuestionnaireTab from "../Component/QuestionnaireTab/QuestionnaireTab";
import BlogDetailsScreen from "../Component/Blog/BlogDetailsScreen";
import PaymentWebView from "../Component/api/PaymentWebView";
import DocumentVerification from "../Component/DocumentVerification/DocumentVerification";
import ProtectedRoute from "../Component/ProtectedRoute/ProtectedRoute";
import Homeoldpage from "../Component/Home/Homeold";
import Servicesold from "../Component/Services/Servicesold";
import Aboutold from "../Component/About/Aboutold";
import Home_2 from "../Component/Home/Home_2";
import Gdpr from "../Component/Gdpr/Gdpr";
import Csae from "../Component/Csae/Csae";
const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // useEffect(() => {
  //   const checkUserStatus = async () => {
  //     try {
  //       const userData = localStorage.getItem("currentUser");
  //       if (userData) {
  //         const parsedUserData = JSON.parse(userData);
  //         const userId = parsedUserData?._id || parsedUserData?.id;

  //         if (userId) {
  //           const currentUser = await getUserById({ user_id: userId });
  //           console.log("Fetched User Data:", currentUser);

  //           const status = currentUser?.data?.profile_completion_status;
  //           if (currentUser?.data?.type === "counsellor") {
  //             const user = currentUser.data;
  //             const status = user.profile_completion_status;

  //             if (user.approve_reject === "pending") {
  //               switch (status) {
  //                 case "emailvarification":
  //                   navigate("/CounsellorEmailVerification");
  //                   break;
  //                 case "uploadDocument":
  //                   navigate("/CounsellorDoucmentation");
  //                   break;
  //                 case "CounsellorImageUpload":
  //                   navigate("/CounsellorImageUpload");
  //                   break;
  //                 case "CounsellorFinalSubmission":
  //                   navigate("/CounsellorFinalSubmission");
  //                   break;
  //                 case "CounsellorSidebar":
  //                   alert("Your profile is under review.");
  //                   if (user.approve_reject === "approved") {
  //                     navigate("/CounsellorTab");
  //                   } else {
  //                     navigate("/CounsellorFinalSubmission");
  //                   }
  //                   break;
  //                 default:
  //                   alert("Redirecting to dashboard.");
  //                   navigate("/CounsellorSidebar");
  //               }
  //             } else if (user.approve_reject === "rejected") {
  //               alert("Your profile was rejected. Please update documents.");
  //               navigate("/CounsellorDoucmentation");
  //             } else {
  //               // alert("Welcome back!");
  //               if (
  //                 user.approve_reject === "approved" &&
  //                 user.profile_completion_status === "Tab"
  //               ) {
  //                 navigate("/CounsellorSidebar");
  //               }
  //             }
  //           } else {
  //             // if (status === "gender") {
  //             //   navigate("/gender");
  //             // } else if (status === "paymentscreen") {
  //             //   navigate("/PaymentScreen");
  //             // } else if (status === "UploadImage") {
  //             //   navigate("/UploadImage");
  //             // } else if (status === "RegistrationVarification") {
  //             //   navigate("/RegistrationVarification");
  //             // } else if (status === "userAnswersValue") {
  //             //   navigate("/ValuesAssessment");
  //             // } else if (status === "userAnswersIQ") {
  //             //   navigate("/IQAssessment");
  //             // } else if (status === "UpdateProfileDetails") {
  //             //   navigate("/UpdateProfileDetails");
  //             // } else if (status === "uploadDocument") {
  //             //   navigate("/DocumentUpload");
  //             // } else if (status === "cultureReligion") {
  //             //   navigate("/CultureReligion");
  //             // } else if (status === "interest") {
  //             //   navigate("/Interest");
  //             // } else if (status === "userAnswersTemperament") {
  //             //   navigate("/TemperamentQuestion");
  //             // } else if (status === "Tab") {
  //             //   navigate("/Sidebar");
  //             // }
  //             if (status === "gender") {
  //               navigate("/gender");
  //             } else if (status === "paymentscreen") {
  //               navigate("/PaymentScreen");
  //             } else if (status === "UploadImage") {
  //               navigate("/UploadImage");
  //             } else if (status === "RegistrationVerification") {
  //               navigate("/RegistrationVerification");
  //             } else if (status === "userAnswersValue") {
  //               navigate("/ValuesAssessment");
  //             } else if (status === "userAnswersIQ") {
  //               navigate("/IQAssessment");
  //             } else if (status === "UpdateProfileDetails") {
  //               navigate("/UpdateProfileDetails");
  //             } else if (status === "Lovelanguage") {
  //               navigate("/Lovelanguage");
  //             } else if (status === "UpdateMatchPreferences") {
  //               navigate("/UpdateMatchPreferences");
  //             } else if (status === "uploadDocument") {
  //               navigate("/DocumentUpload");
  //             } else if (status === "cultureReligion") {
  //               navigate("/CultureReligion");
  //             } else if (status === "interest") {
  //               navigate("/Interest");
  //             } else if (status === "userAnswersTemperament") {
  //               navigate("/TemperamentQuestion");
  //             } else if (
  //               currentUser?.data?.approve_reject === "approved" &&
  //               currentUser?.data?.profile_completion_status === "Tab"
  //             ) {
  //               if (currentUser?.data?.activeSubscriptionStatus !== "0") {
  //                 navigate("/Sidebar");
  //               } else {
  //                 navigate("/SubscriptionBlurPage");
  //               }
  //             } else {
  //               navigate("/FinalSubmissionPage");
  //             }
  //           }
  //         } else {
  //           navigate("/");
  //         }
  //       } else {
  //         // if (storedInfluencer) {
  //         //   navigate("InfluencerPage");
  //         // } else {
  //         navigate("/");
  //         //   }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching user data:", error);
  //       navigate("/");
  //     }
  //   };

  //   if (location.pathname === "/") {
  //     checkUserStatus();
  //   }
  // }, []);

  const hideHeaderRoutes = [];

  const shouldShowHeader = !hideHeaderRoutes.some((route) =>
    route.test(location.pathname)
  );

  return (
    <>
      {shouldShowHeader && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Homeoldpage" element={<Homeoldpage />} />
        <Route path="/servicesold" element={<Servicesold />} />
        <Route path="*" element={<Navigate to="/Login" replace />} />
        <Route path="/Login" element={<AuthPage />} />
        <Route path="/AffiliateAccess" element={<InfluencerLoginPage />} />
        <Route path="/RegistrationPage" element={<RegistrationPage />} />
        <Route path="/InfluencerPage" element={<InfluencerPage />} />
        <Route path="/Aboutold" element={<Aboutold />} />
        <Route path="/Home_2" element={<Home_2 />} />
        <Route
          path="/UpdateProfileDetails"
          element={<UpdateProfileDetails />}
        />
        <Route
          path="/ConnectionPaymentWebView"
          element={<ConnectionPaymentWebView />}
        />
        <Route path="/PaymentWebView" element={<PaymentWebView />} />

        <Route path="/InflucerEnterCode" element={<InflucerEnterCode />} />
        <Route
          path="/InfluencerResetPasswordPage"
          element={<InfluencerResetPasswordPage />}
        />
        <Route
          path="/SubscriptionBlurPage"
          element={<SubscriptionBlurPage />}
        />
        <Route
          path="/UpdateMatchPreferences"
          element={<UpdateMatchPreferences />}
        />

        <Route path="/SubscriptionPlans" element={<SubscriptionPlans />} />
        <Route path="/About" element={<About />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/BlogDetailsScreen" element={<BlogDetailsScreen />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route
          path="/RegistrationVarification"
          element={<RegistrationVarification />}
        />
        <Route
          path="/DocumentVerification"
          element={<DocumentVerification />}
        />

        <Route
          path="/CounsellorEmailVerification"
          element={<CounsellorEmailVerification />}
        />
        <Route
          path="/CounsellorImageUpload"
          element={<CounsellorImageUpload />}
        />
        <Route
          path="/CounsellorDoucmentation"
          element={<CounsellorDoucmentation />}
        />
        <Route
          path="/CounsellorFinalSubmission"
          element={<CounsellorFinalSubmission />}
        />

        <Route path="/gender" element={<GenderPage />} />
        <Route
          path="/CounsellorRegistration"
          element={<CounsellorRegistrations />}
        />
        <Route
          path="/CounsellorForgotPassword"
          element={<CounsellorForgotPassword />}
        />
        <Route path="/Lovelanguage" element={<Lovelanguage />} />

        <Route path="/CounsellorOtp" element={<CounsellorOtp />} />
        <Route path="/UploadImage" element={<UploadImage />} />
        <Route path="/PaymentScreen" element={<PaymentScreen />} />
        <Route path="/DocumentUpload" element={<DocumentUpload />} />
        <Route path="/CultureReligion" element={<CultureReligion />} />
        <Route path="/Interest" element={<Interest />} />
        <Route path="/TemperamentQuestion" element={<TemperamentQuestion />} />
        <Route path="/ValuesAssessment" element={<ValuesAssessment />} />
        <Route path="/IQAssessment" element={<IQAssessment />} />
        <Route path="/FinalSubmissionPage" element={<FinalSubmissionPage />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/Verification" element={<Verification />} />
        <Route path="/UserHomePage" element={<UserHomePage />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/Gdpr" element={<Gdpr />} />
        <Route path="/Csae" element={<Csae />} />
        <Route path="/termsandcondition" element={<TermsandCondition />} />
        <Route path="/PaymentHistory" element={<PaymentHistory />} />
        <Route path="/CounsellorChat" element={<CounsellorChat />} />

        <Route
          path="/Sidebar"
          element={
            <ProtectedRoute>
              <Sidebar />
            </ProtectedRoute>
          }
        >
          <Route path="home" element={<UserHomePage />} />
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<h1>Settings Page</h1>} />
          <Route path="notification" element={<Notification />} />
          <Route path="helpandsupport" element={<HelpandSupport />} />
          <Route
            path="/Sidebar/MemberProfile/:memberId"
            element={<MemberProfile />}
          />
          <Route path="/Sidebar/chat/:id" element={<Chat />} />
          <Route path="/Sidebar/Messages/" element={<Messages />} />
          {/* <Route path="BookingDetails" element={<BookingDetails />} /> */}
          <Route path="BookingDetails/:id" element={<BookingDetails />} />
          <Route
            path="/Sidebar/QuestionnaireTab"
            element={<QuestionnaireTab />}
          />
          <Route
            path="/Sidebar/BlogDetailsScreen"
            element={<BlogDetailsScreen />}
          />

          <Route path="/Sidebar/Blog" element={<Blog />} />

          <Route path="ConnectionPayment/:id" element={<ConnectionPayment />} />
          {/* navigate(`/Sidebar/ConnectionPayment/${id}`); */}
          {/* BookingDetails */}
          <Route path="EditProfile" element={<EditProfile />} />
          {/* ------------------ */}
          <Route
            path="/Sidebar/UserBasicDetailsEdit"
            element={<UserBasicDetailsEdit />}
          />
          <Route path="/Sidebar/UserImageEdit" element={<UserImageEdit />} />
          <Route
            path="/Sidebar/UpdateuploadProfileDetails"
            element={<UpdateuploadProfileDetails />}
          />
          <Route
            path="/Sidebar/UpdateUploadMatchPreferences"
            element={<UpdateUploadMatchPreferences />}
          />
          <Route path="/Sidebar/ResetPassword" element={<ResetPassword />} />
          <Route path="/Sidebar/EditInterest" element={<EditInterest />} />
          {/* <Route path="/Sidebar/ChatConsult" element={<ChatConsult />} /> */}

          <Route
            path="/Sidebar/EditCultureReligion"
            element={<EditCultureReligion />}
          />
          <Route
            path="/Sidebar/SetResetPassword"
            element={<SetResetPassword />}
          />
          <Route path="/Sidebar/AdminSupport" element={<AdminSupport />} />
          <Route path="/Sidebar/PaymentDispute" element={<PaymentDispute />} />
          <Route path="/Sidebar/TechSupport" element={<TechSupport />} />
          <Route path="/Sidebar/PaymentHistory" element={<PaymentHistory />} />
          <Route path="/Sidebar/Consult" element={<Consult />} />
          <Route
            path="/Sidebar/ConsultPaymentWebView"
            element={<ConsultPaymentWebView />}
          />
          <Route path="/Sidebar/Subscription" element={<Subscription />} />
          <Route
            path="/Sidebar/ConnectionPaymentWebView"
            element={<ConnectionPaymentWebView />}
          />

          <Route path="/Sidebar/ChatConsult" element={<ChatConsult />} />
        </Route>

        <Route path="/CounsellorSidebar" element={<CounsellorSidebar />}>
          <Route path="CounsellorBooking" element={<CounsellorBooking />} />
          <Route path="Rating" element={<Rating />} />
          <Route
            path="CounsellorEditProfile"
            element={<CounsellorEditProfile />}
          />
          <Route
            path="CounsellorImageUpdate"
            element={<CounsellorImageUpdate />}
          />
          <Route path="Availabilityupdate" element={<Availabilityupdate />} />
          <Route
            path="CounsellorProfileEdit"
            element={<CounsellorProfileEdit />}
          />
          <Route path="Resetpassword" element={<Resetpassword />} />
          <Route
            path="CounsellorResetPassword"
            element={<CounsellorResetPassword />}
          />
          {/* <Route path="CounsellorChat" element={<CounsellorChat />} /> */}
          <Route path="CounsellorChat/:id" element={<CounsellorChat />} />

          {/* <Route path="profile" element={<Profile />} /> */}
          {/* <Route path="/ChatConsult" element={<ChatConsult />} /> */}
          {/* <Route path="settings" element={<h1>Settings Page</h1>} />
          <Route path="notification" element={<Notification />} />
          <Route path="helpandsupport" element={<HelpandSupport />} /> */}
          {/* <Route path="MemberProfile" element={<MemberProfile />} /> */}

          {/* <Route path="/Sidebar/chat/:id" element={<Chat />} />
          <Route path="/Sidebar/Messages/" element={<Messages />} />
          <Route path="EditProfile" element={<EditProfile />} /> */}
          {/* ------------------ */}
          {/* <Route
            path="/Sidebar/UserBasicDetailsEdit"
            element={<UserBasicDetailsEdit />}
          /> */}
          {/* <Route path="/Sidebar/UserImageEdit" element={<UserImageEdit />} />
          <Route path="/Sidebar/ResetPassword" element={<ResetPassword />} />
          <Route path="/Sidebar/EditInterest" element={<EditInterest />} /> */}
          {/* <Route path="/Sidebar/ChatConsult" element={<ChatConsult />} /> */}

          {/* <Route
            path="/Sidebar/EditCultureReligion"
            element={<EditCultureReligion />}
          />
          <Route
            path="/Sidebar/SetResetPassword"
            element={<SetResetPassword />}
          />
          <Route path="/Sidebar/AdminSupport" element={<AdminSupport />} />
          <Route path="/Sidebar/PaymentDispute" element={<PaymentDispute />} />
          <Route path="/Sidebar/TechSupport" element={<TechSupport />} />
          <Route path="/Sidebar/PaymentHistory" element={<PaymentHistory />} />
          <Route path="/Sidebar/Consult" element={<Consult />} />
          <Route
            path="/Sidebar/ConsultPaymentWebView"
            element={<ConsultPaymentWebView />}
          />
          <Route path="/Sidebar/ChatConsult" element={<ChatConsult />} /> */}
        </Route>
      </Routes>
    </>
  );
};

export default Navigation;
